const EPAYCO_SCRIPT_ID = 'epayco-checkout-js';
const EPAYCO_SCRIPT_URL = 'https://checkout.epayco.co/checkout.js';

let epaycoStyleInjected = false;

const injectEpaycoZIndexFix = () => {
  if (epaycoStyleInjected || typeof document === 'undefined') return;
  const style = document.createElement('style');
  style.id = 'epayco-zfix-style';
  style.textContent = `
    .epayco-checkout-container,
    .epayco-checkout,
    .epayco-modal,
    iframe[src*="epayco"],
    iframe[src*="checkout.epayco"] {
      z-index: 2147483646 !important;
    }
  `;
  document.head.appendChild(style);
  epaycoStyleInjected = true;
};

export const loadEpaycoScript = () =>
  new Promise((resolve, reject) => {
    injectEpaycoZIndexFix();

    if (window.ePayco?.checkout) {
      resolve(window.ePayco);
      return;
    }

    let script = document.getElementById(EPAYCO_SCRIPT_ID);
    if (!script) {
      script = document.createElement('script');
      script.id = EPAYCO_SCRIPT_ID;
      script.src = EPAYCO_SCRIPT_URL;
      script.async = true;
      document.body.appendChild(script);
    }

    const timeout = setTimeout(() => {
      reject(new Error('Tiempo de espera agotado al cargar ePayco'));
    }, 15000);

    script.onload = () => {
      clearTimeout(timeout);
      if (window.ePayco?.checkout) {
        resolve(window.ePayco);
      } else {
        reject(new Error('ePayco no quedó disponible después de cargar el script'));
      }
    };

    script.onerror = () => {
      clearTimeout(timeout);
      reject(new Error('No se pudo cargar el script de ePayco'));
    };
  });

export const buildEpaycoCheckoutData = (epaycoData) => ({
  name: epaycoData.description || 'Upgrade a Plan Premium - Redplika',
  description: epaycoData.description || 'Upgrade a Plan Premium - Redplika',
  invoice: epaycoData.invoice || epaycoData.referenceCode,
  currency: epaycoData.currency || 'COP',
  amount: String(epaycoData.amount ?? epaycoData.precio ?? ''),
  tax_base: String(epaycoData.tax_base ?? epaycoData.amount ?? epaycoData.precio ?? ''),
  tax: String(epaycoData.tax ?? 0),
  country: epaycoData.country || 'CO',
  lang: 'es',
  email_billing: epaycoData.email || epaycoData.correo || '',
  response: epaycoData.responseUrl,
  confirmation: epaycoData.confirmationUrl,
  doc_type: epaycoData.doc_type || 'CC',
  doc_number: epaycoData.doc_number || '',
  name_billing: epaycoData.name || '',
  last_name: epaycoData.last_name || '',
  cell_phone: epaycoData.cell_phone || '',
  x_extra1: epaycoData.x_extra1,
  x_extra2: epaycoData.x_extra2,
  x_extra3: epaycoData.x_extra3,
  x_extra4: epaycoData.x_extra4,
  x_extra5: epaycoData.x_extra5,
  x_extra6: epaycoData.x_extra6,
});

export const openEpaycoCheckout = async (epaycoData) => {
  const ePayco = await loadEpaycoScript();
  const handler = ePayco.checkout.configure({
    key: epaycoData.publicKey,
    test: epaycoData.test ?? epaycoData.testMode ?? false,
  });
  handler.open(buildEpaycoCheckoutData(epaycoData));
  return epaycoData;
};
